export default __webpack_public_path__ + "static/media/ProofPaymentScreenDesktop.5e061a26.svg";